<template lang="pug">
span#reports
  .md-layout
    .md-layout-item.ml-auto
      md-button.md-warning(
        style='float: right;'
        @click='filterDialog = true')
        v-icon(style='color: black !important; padding-right: 4px;') mdi-filter-variant
        span(style='color: black')
          | {{$t('chatHistory.filter')}}
  div.md-layout
    div.md-layout-item.md-medium-size-50.md-xsmall-size-100(:class='tenant==this.tenant ? "md-size-36": "md-size-25"')
      DataProvider(:endpoint='mountUrlAndParams("notificationsSent").url' :filter='filter' @success='handleContent("notificationsSent", $event)' ref='dataProviderSent')
        div(slot-scope='{ data: response, error, loading }')
          v-skeleton-loader(
            v-if='loading'
            height='110'
            style='margin: 30px 0;'
            type='list-item-avatar-three-line')
          stats-card(v-else header-color="blue")
            template(slot="header")
              div.card-icon
                ChatSended
              p.category {{ $t('campaign.campaignSent') }}
              h3.title
                div
                  animated-number(:value='notificationsSent')
              br
    div.md-layout-item.md-medium-size-50.md-xsmall-size-100(:class='tenant==this.tenant ? "md-size-36": "md-size-25"')
      DataProvider(:endpoint='mountUrlAndParams("notificationsDelivered").url' :filter='filter' @success='handleContent("notificationsDelivered", $event)' ref='dataProviderDelivery')
        div(slot-scope='{ data: response, error, loading }')
          v-skeleton-loader(
            v-if='loading'
            height='110'
            style='margin: 30px 0;'
            type='list-item-avatar-three-line')
          stats-card(v-else header-color="rose")
            template(slot="header")
              div.card-icon
                ChatReceived
              p.category {{ $t('campaign.campaignDelivery') }}
              h3.title
                div.boxRow
                  animated-number(:value='percentageDelivered')
                  p %
              p.category
                div.boxRow
                  animated-number(:value='notificationsDelivered')
    div.md-layout-item.md-medium-size-50.md-xsmall-size-100(:class='tenant==this.tenant ? "md-size-36": "md-size-25"')
      DataProvider(:endpoint='mountUrlAndParams("notificationsRead").url' :filter='filter' @success='handleContent("notificationsRead", $event)' ref='dataProviderRead')
        div(slot-scope='{ data: response, error, loading }')
          v-skeleton-loader(
            v-if='loading'
            height='110'
            style='margin: 30px 0;'
            type='list-item-avatar-three-line')
          stats-card(v-else header-color="green")
            template(slot="header")
              div.card-icon
                ChatRead
              p.category {{ $t('campaign.campaignRead') }}
              h3.title
                div.boxRow
                  animated-number(:value='percentageRead')
                  p %
              p.category
                div
                  animated-number(:value='notificationsRead')
  div
    DataProvider(:key="listAllcomponentKey" :endpoint='mountUrlAndParams("listAll").url' :filter='filter' ref='dataProvider')
      div(slot-scope='{ data: response, error, loading }')
        DataTable(
          :data='response.data.slice(perPage * page - perPage, perPage * page)'
          ref='dataTable'
          :title="$t('campaign.campaignFiringList')"
          :customTotal='(response && response.total) || 0'
          @pagination='handlePagination'
          :currentSort.sync='filter.orderBy'
          :currentSortOrder.sync='filter.order'
          :selectable='false'
          :loading='loading'
          customHeader
          :endpoint='mountUrlAndParams("listAll").url'
          :filter='filter'
          :labels='labels'
          :formatLabelFunction='formatLabels'
          :fileName="$t('campaign.fileName')"
          orientationPDF="landscape"
          :createHeader='createHeaderPDF')
          template(slot='footer' slot-scope='{ pagination }')
            v-row(style='justify-content: flex-end;')
              v-col(cols='auto')
                md-field
                  label(for='pages') {{ $t('assistantsList.perPage') }}
                  md-select(v-model='pagination.perPage' name='pages' )
                    md-option(
                      v-for='item in handlePaginationContent(pagination.perPageOptions, response.data)',
                      :key='item',
                      :label='item',
                      :value='item')
                      | {{ item }}
          template(slot='cells' slot-scope='{ item }')
            md-table-cell(:md-label='labels[0]') {{ formatLabels(item, 0) }}
            md-table-cell(:md-label='labels[1]') {{ formatLabels(item, 1) }}
            md-table-cell(:md-label='labels[2]') {{ formatLabels(item, 2) }}
            md-table-cell(:md-label='labels[3]') {{ formatLabels(item, 3) }}
            md-table-cell(:md-label='labels[4]') {{ formatLabels(item, 4) }}
            md-table-cell(:md-label='labels[5]') {{ formatLabels(item, 5) }}
            md-table-cell(:md-label='labels[6]') {{ formatLabels(item, 6) }}
            md-table-cell(:md-label='labels[7]') {{ formatLabels(item, 7) }}
            md-table-cell(:md-label='$t("campaign.campaignAllAction")')
              v-row(no-gutters style='justify-content: flex-end;')
                v-col(cols='auto')
                  v-btn(
                    x-small
                    fab
                    depressed
                    color="#20A6E5"
                    style="color: #FFFFFF;!important"
                    @click='openDialog("TriggeredNotificationDialog", item)'
                    :disabled='isDateLaterThanNovember(item.interval.endDate)'
                  )
                    v-icon(dark )
                      | visibility
                v-col(cols='auto')
                  v-btn(
                    class="mx-2"
                    x-small
                    fab
                    depressed
                    color="#CC3C69"
                    @click='openNotificationStatus(item)'
                  )
                    ChatAction
    NotificationTriggeredList(
      :dialog.sync='dialogNotificationStatus'
      :campaignId='campaignId'
      :componentKey='componentKey'
      :selectedDate='selectedDate'
    )
    GlobalDialog(
      v-model='filterDialog'
      max-width='700px'
      scrollable
      :headerTitle="$t('campaign.listOfTriggeredTriggers')"
      showMButton
      mButtonTextColor='#FE544F'
      mButtonColor='#FE544F'
      mButtonIsOutlined
      :mButtonTitle="$t('chatHistory.reset')"
      @clickMButton='resetFilter()'
      showRButton
      :rButtonTitle="$t('chatHistory.apply')"
      @clickRButton='saveFilter()')
      template(v-slot:content)
        v-col
          h3 {{ $t('campaign.campaignData') }}
          v-row
            v-col.ml-4
              v-select(
                v-model="selectedCampaign"
                @change="handleFilterOptions('campaignName', $event)"
                :label="$t('campaign.campaignName')"
                item-text="text"
                item-value="value"
                :items="campaignList"
                multiple
              )
            v-col
              v-select(
                v-model="selectedChanels"
                @change="handleFilterOptions('channel', $event)"
                :label="$t('campaign.campaignChannel')"
                item-text="text"
                item-value="value"
                :items="channelList"
                multiple
              )
    template(v-if='TriggeredNotificationDialog')
      TriggereNotificationModal(
        :showTriggerNotificationDialog='TriggeredNotificationDialog'
        :campaignData='campaignObj'
        @closeTriggerNotificationDialog='closeDialog("TriggeredNotificationDialog")'
      )

</template>
<script>
import { selectedLocale } from '@/plugins/i18n'
import { mapFields } from 'vuex-map-fields'
import moment from 'moment'
import StatsCard from '@/components/Cards/StatsCard.vue'
import AnimatedNumber from '@/components/AnimatedNumber'
import DataProvider from '@/components/DataProvider'
import GlobalDialog from '@/components/Reuse/GlobalDialog'
import NotificationTriggeredList from '@/components/NotificationCampaign/NotificationTriggeredList.vue'
import CardNoData from '@/components/CardNoData'
import DataTable from '@/components/DataTable'
import TriggereNotificationModal from '@/components/TriggeredNotification.vue'
import ChatSended from '@/assets/img/mark_chat_sended.svg'
import ChatRead from '@/assets/img/mark_chat_read.svg'
import ChatReceived from '@/assets/img/mark_chat_received.svg'
import ChatAction from '@/assets/img/checklist_action.svg'
import isTenantMixin from '@/components/mixins/isTenantMixin'

const initialChannels = [
  { text: 'Instagram', name: 'instagram', isActive: false, status: '' },
  { text: 'Push', name: 'push', isActive: false, status: '' },
  { text: 'SMS', name: 'sms', isActive: false, status: '' },
  { text: 'Teams', name: 'teams', isActive: false, status: '' },
  { text: 'WhatsApp', name: 'whatsapp', isActive: false, status: '' }
]

export default {
  data () {
    return {
      dataList: [],
      dataListBase: [],
      page: 1,
      perPage: 5,
      selectedDate: null,
      channelList: [ ...initialChannels ],
      campaignList: [],
      selectedCampaign: null,
      selectedChanels: null,
      filterDialog: false,
      TriggeredNotificationDialog: false,
      notificationsSent: 0,
      notificationsRead: 0,
      percentageRead: 0,
      notificationsDelivered: 0,
      percentageDelivered: 0,
      componentKey: 0,
      listAllcomponentKey: 0,
      dialogNotificationStatus: false,
      campaignId: '',
      campaignObj: {},
      labels: [this.$t('search.start'), this.$t('chatTable.end'), this.$t('routes.campaign'), this.$t('campaign.campaignChannel'), this.$t('campaign.campaignAllSent'), this.$t('campaign.campaignDelivered'), this.$t('campaign.campaignAllRead'), this.$t('campaign.conversationsStarted')],
      allFilter: null,
      filter: {
        order: 'desc',
        page: 0,
        perPage: 5
      }
    }
  },
  mixins: [isTenantMixin],
  created () {
    this.requestCampaignNames()
    this.filter = {
      ...this.filter,
      from: this.dateInterval.timestamp1,
      to: this.dateInterval.timestamp2,
      select: this.dateInterval?.select?.value
    }
  },
  watch: {
    dateInterval: {
      deep: true,
      handler (nV) {
        this.updatedDate()
      }
    }
  },
  components: {
    AnimatedNumber,
    ChatRead,
    ChatReceived,
    ChatAction,
    ChatSended,
    StatsCard,
    NotificationTriggeredList,
    GlobalDialog,
    DataProvider,
    CardNoData,
    DataTable,
    TriggereNotificationModal
  },
  computed: {
    ...mapFields('reports', ['dateInterval'])
  },
  methods: {
    openDialog (whichDialog, selectedCampaign) {
      this[whichDialog] = true
      this.campaignObj = selectedCampaign
    },
    closeDialog (whichDialog) {
      this[whichDialog] = false
      this.campaignObj = {}
    },
    isDateLaterThanNovember (date) {
      const referenceDate = moment('2024-12-01', 'YYYY-MM-DD')
      const endDate = moment(date)
      const result = endDate.isSameOrAfter(referenceDate)
      return !result
    },
    handlePaginationContent (pageItems, data) {
      this.dataListBase = data
      this.dataList = data
      return pageItems
    },
    handlePagination (pagination, oldPagination) {
      const { currentPage, perPage } = pagination
      this.page = currentPage
      if (currentPage !== this.page) {
        this.page = currentPage - 1
      }
      if (perPage !== this.perPage) {
        this.perPage = perPage
      }
    },
    requestCampaignNames () {
      let initialCampaign = []
      const { url, filter } = this.mountUrlAndParams('names')
      try {
        this.$axios.get(`${url}`, {
          params: { ...this.filter, time_zone: '-03:00', from: filter.from, to: filter.to }
        }).then(response => {
          if (response && response.status === 200) {
            if (response.data.length) {
              for (let i = 0; i < response.data.length; i++) {
                initialCampaign.push({ text: response.data[i], name: '', isActive: false, status: '' })
              }
              this.campaignList = initialCampaign
            }
          }
        })
      } catch (error) {
      }
    },
    handleFilterOptions (key, event) {
      let items = key === 'channel' ? event.toString().toLowerCase() : event.toString()
      this.allFilter = { ...this.allFilter, [key]: items }
    },
    updateComponentID () {
      this.componentKey += 1
    },
    resetFilter () {
      this.selectedCampaign = null
      this.selectedChanels = null
      this.saveFilter(true)
    },
    saveFilter (update = false) {
      if (update) {
        this.$delete(this.filter, 'channel')
        this.$delete(this.filter, 'campaignName')
      }
      if (this.allFilter) {
        const filters = { ...this.filter, ...this.allFilter }
        this.filter = filters
        this.allFilter = null
      }
      this.filterDialog = false
    },
    openNotificationStatus (item) {
      this.updateComponentID()
      this.selectedDate = { from: this.filter.from, to: this.filter.to }
      this.campaignId = item.campaignId
      this.dialogNotificationStatus = true
    },
    updatedDate () {
      this.filter.from = this.dateInterval.timestamp1
      this.filter.to = this.dateInterval.timestamp2
      this.requestCampaignNames()
      this.$refs.dataProvider.load()
      this.$refs.dataProviderSent.load()
      this.$refs.dataProviderDelivery.load()
      this.$refs.dataProviderRead.load()
    },
    async handleContent (key, response) {
      if (key === 'notificationsSent') {
        this.notificationsSent = response.data.notificationsSent
      }
      if (key === 'notificationsDelivered') {
        this.notificationsDelivered = response.data.notificationsDelivered
        this.percentageDelivered = response.data.percentageDelivered
      }
      if (key === 'notificationsRead') {
        this.notificationsRead = response.data.notificationsRead
        this.percentageRead = response.data.percentageRead
      }
    },
    mountUrlAndParams (endpoint) {
      const from = this.dateInterval.timestamp1
      const to = this.dateInterval.timestamp2
      const select = this.dateInterval?.select?.value
      return {
        url: `${process.env.VUE_APP_REPORTS_BACKEND}/campaign/${endpoint}`,
        filter: { to, from, select: select }
      }
    },
    formatDate (date) {
      return moment(date).locale(selectedLocale).format('L LT')
    },
    formatLabels (item, i) {
      switch (i) {
        case 0:
          return this.formatDate(item.interval.startDate)
        case 1:
          return item.interval.endDate ? this.formatDate(item.interval.endDate) : '-'
        case 2:
          return item.campaignName
        case 3:
          return item.channel
        case 4:
          return item.notificationsSent
        case 5:
          return item.notificationsDelivered
        case 6:
          return item.notificationsRead
        case 7:
          return item.notificationsProactive
        default:
          break
      }
    },
    createHeaderPDF (doc, total) {
      doc.setFontSize(14)
      doc.setFont(undefined, undefined, '700')
      doc.text(15, 10, this.$t('campaign.campaignFiringList'))
      doc.setFontSize(10)
      doc.setFont('times', undefined, '700')
      doc.text(15, 17, this.$t('chatTable.timeCourse'))
      doc.setFont('times', undefined, '300')

      let formattedDate1 = moment(this.filter.from).locale(selectedLocale).format('L LTS')
      let formattedDate2 = moment(this.filter.to).locale(selectedLocale).format('L LTS')
      doc.text(29, 17, `${formattedDate1} até ${formattedDate2}`)

      doc.setFont('times', undefined, '700')
      doc.text(15, 22, this.$t('chatTable.totalConversations'))
      doc.setFont(undefined, undefined, '300')
      doc.text(46, 22, `${total}`)

      const tableOffsetY = 30
      return tableOffsetY
    }
  }
}
</script>
<style lang="scss">
.boxRow {
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
}

.md-table-head-label, .md-table-cell {
  font-weight: 400 !important;
}

.md-content {
  table thead tr th:nth-child(8) {
    width: 11.7rem !important;
  }
}
#reports .v-skeleton-loader .v-skeleton-loader__list-item-avatar-three-line {
  height: 110px !important;
}
#reports .v-skeleton-loader .v-skeleton-loader__list-item-avatar-three-line .v-skeleton-loader__paragraph {
  padding-left: 4px !important;
}
</style>
